<template>
  <div>
    <h2>Уведомление</h2>

    <br/>
    <div class="row g-3">

      <div class="row col-md-6">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">БИН</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="bin" v-model="searchParams.bin">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-6">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  track-by="code"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-6">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">Наименование</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="bin" v-model="searchParams.name">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-6">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">Исполнитель</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="bin" v-model="searchParams.executor">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-6">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">Финансирование</label>
          <div class="col-md-9">
            <div class="input-group">
              <select v-model="searchParams.fundingStatus" id="fundingStatus" class="form-control">
                <option :value="null">Все статусы</option>
                <option value="IN_PROGRESS">Осуществляется</option>
                <option value="SUSPENDED">Приостановлено</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row col-md-6">
        <div class="el-input-group">
          <label for="signStatus" class="form-label col-md-3">По статусу</label>
          <div class="col-md-9">
            <div class="input-group">
              <select v-model="searchParams.lastMessageStatus" id="notificationStatus" class="form-control">
                <option :value="null">Все статусы</option>
                <option value="SENT">Отправлено</option>
                <option value="DELIVERED">Доставлено</option>
              </select>
            </div>
          </div>
        </div>
      </div>



      <div class="col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchReports(true)">Поиск</button>
          <button class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
          <button v-if="!isLoading" class="btn btn-info" @click="downloadGeneratedCalculationReportList()">Выгрузить результат по фильтру</button>
          <button v-else class="btn btn-loading" disabled>Загрузка</button>
        </div>
      </div>


    </div>


    <div class="row">
      <div class="col-md-4">
        <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParams.pageSize"></b-pagination>
      </div>
      <div class="col-md-4">
        <span>Элементов в странице: </span>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" :class="{'active': searchParams.pageSize == 10}" @click="changePageElementSize(10)">10</button>
          <button type="button" class="btn btn-secondary" :class="{'active': searchParams.pageSize == 50}" @click="changePageElementSize(50)">50</button>
          <button type="button" class="btn btn-secondary" :class="{'active': searchParams.pageSize == 100}" @click="changePageElementSize(100)">100</button>
        </div>
      </div>
    </div>
    <el-table :data="items" style="width: 100%">
      <el-table-column
          label="#"
          width="50">
        <template #default="scope">
        {{searchParams.pageSize * searchParams.page + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
          label="БИН">
        <template #default="scope">
          <a @click="openNotificationModal(scope.row)" href="#">
            {{ scope.row.bin }}
          </a>
        </template>
      </el-table-column>

      <el-table-column label="Название ДО">
        <template #default="scope">
          {{ scope.row.kindergartenName }}
        </template>
      </el-table-column>
      <el-table-column label="LMS ID">
        <template #default="scope">
          {{ scope.row.lmsId }}
        </template>
      </el-table-column>
      <el-table-column label="Населенный пункт">
        <template #default="scope">
          {{ getKatoNameRu(scope.row.katoCode) }}
        </template>
      </el-table-column>

      <el-table-column label="Адрес">
        <template #default="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>



      <el-table-column  label="Статус">
        <template #default="scope">
          {{ getLastMessageStatusText(scope.row.lastMessageStatus) }}
        </template>
      </el-table-column>


      <el-table-column label="Финансирование">
        <template #default="scope">
          {{ getFundingStatusText(scope.row.fundingStatus) }}
        </template>
      </el-table-column>

      <el-table-column label="Исполнитель">
        <template #default="scope">
          {{ scope.row.fundingStatusSuspendedByUser }}
        </template>
      </el-table-column>
    </el-table>
  </div>


  <!-- Modal component -->
  <b-modal v-model="showModal" :title="messageModalTitle" size="xl">
    <form class="mb-12">
      <section>
        <div class="container py-5.">
          <div style="width: 100%; padding-bottom: 5px">

            <div class="row">
              <div class="col-auto">
                <b class="padding-r-5px">Населенный пункт:</b>
                {{getKatoNameRu(lmsSystemNotificationDto?.katoCode)}}
              </div>


              <div class="col-auto" >
                <b class="padding-r-5px">Адрес:</b>
                {{lmsSystemNotificationDto?.address}}
              </div>

              <div class="col-auto">
                <b class="padding-r-5px">Финансирование:</b>
                {{ getFundingStatusText(lmsSystemNotificationDto?.fundingStatus) }}
              </div>

              <div class="col-auto">
                <b class="padding-r-5px">Контакты:</b>
                {{ lmsSystemNotificationDto?.directorPhone }}
              </div>

            </div>
          </div>

          <div class="messaging">
            <div class="inbox_msg">
              <div class="mesgs">
                <div class="msg_history">

                  <div v-if="messages.length && messages[0]?.totalRowCounts > messages.length"
                       style="text-align: center; padding-top: 10px; font-size: 14px; cursor: pointer; text-decoration: underline">
                    <a @click="loadOldMessages">&lt;&lt;Загрузить старые сообщение &gt;&gt;</a>
                  </div>

                  <!--                      -->
                  <div :class="item.sendByManager ? 'outgoing_msg' : 'incoming_msg'" v-for="item in messages">
                    <div class="incoming_msg_img" v-if="!item.sendByManager">
                      <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil">
                    </div>
                    <div :class="item.sendByManager ? 'sent_msg' : 'received_msg'">
                      <div :class="item.sendByManager ? '' : 'received_withd_msg'">
                        <p>
                          {{item.message}}
                        </p>
                        <div v-for="file in item.fileDtos">
                          <a href="javascript:void(0)" @click="downloadFile(file)" style="font-size: 10px">{{file.fileName}} ({{(file.size / 1024).toFixed(2)}}Kb)</a>
                        </div>
                        <span class="time_date">
                          {{ item.createdAt }} | {{item.createdByFullName}}  <span style="float: right; margin-right: 5px">{{getLastMessageStatusText(item.status)}}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="type_msg" v-if="isEditable">
                  <div class="input_msg_write">
                    <input type="text"
                           v-model="messageDto"
                           :disabled="lmsSystemNotificationDto?.notificationStatus != 'OPEN'"
                           class="write_msg"
                           @keyup.enter="messageDto.trim() && sendMessage()"
                           @keypress.enter.prevent
                           placeholder="Введите текст сообщение" />
                    <button class="msg_send_btn" type="button"
                            :disabled="lmsSystemNotificationDto?.notificationStatus != 'OPEN'"
                            @click="sendMessage()">
                      <font-awesome-icon :icon="['fas', 'fa-paper-plane']" />
                    </button>

                    <button class="upload_send_btn" type="button"
                            :disabled="lmsSystemNotificationDto?.notificationStatus != 'OPEN'"
                            @click="triggerFileInput">
                      <font-awesome-icon :icon="['fas', 'fa-upload']" />
                    </button>

                    <input type="file" id="fileUpload"
                           ref="fileInput"
                           @change="handleFileUpload"
                           multiple
                           style="display: none"
                           accept=".pdf, .doc, .docx, .xls, .xlsx" class="form-control"/>
                  </div>
                  <div class="selected-file-item">
                    <span v-for="(file, index) in messageSelectedFiles" :key="index">
                     {{index + 1}}) {{file.name}}
                       <a @click="removeFile(index)">❌</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>
    </form>

    <!-- Кастомные кнопки в футере -->
    <template #footer>
      <b-button v-if="isEditable && lmsSystemNotificationDto?.notificationStatus != 'OPEN'" variant="primary" @click="startNotification(true)">Начать диалог</b-button>
      <b-button v-if="isEditable && lmsSystemNotificationDto?.notificationStatus == 'OPEN'" variant="danger" @click="startNotification(false)">Прекратить</b-button>
      <b-button v-if="isEditable && lmsSystemNotificationDto?.fundingStatus == 'IN_PROGRESS'" variant="danger" @click="startLmsSystemFunding(false)">Прекратить финансирования</b-button>
      <b-button v-if="isEditable && lmsSystemNotificationDto?.fundingStatus != 'IN_PROGRESS'" variant="success" @click="startLmsSystemFunding(true)">Снять со стоп листа</b-button>
      <b-button variant="secondary" @click="showModal = false">Закрыть</b-button>
    </template>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, reactive, watch} from 'vue';
import {
  KdgNotificationSearchParam,
  KdgLmsSystemNotificationDto,
  KdgLmsSystemNotificationRequestDto,
  KdgLmsSystemNotificationMessageDto,
  KdgLmsSystemNotificationMessageRequestDto
} from '@/types/report';
import {PageResponse} from "@/types/pageResponse";
import Multiselect from "vue-multiselect";
import {Kato} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import authService from "@/services/authService";
import {
  findAllLmsSystemNotification,
  findByIdLmsSystemNotification, getGenerateAndExportListAsXLSX,
  getLmsSystemNotificationMessages,
  sendLmsSystemNotificationMessage,
  sendLmsSystemNotificationMessageWithFiles,
  startLmsSystemNotificationMessage
} from "@/services/notificationService";
import {showErrorNotification} from "@/utils/notificationUtils";
import {updateLmsSystemFundingStatus} from "@/services/lmsService";
import VueLoading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/css/index.css';
import {generateReport} from "@/services/actService";
import {TemplateTypeEnum} from "@/enums/TemplateType";
import {downloadFileById} from "@/services/fileService";
import {saveAs} from "file-saver";

export default defineComponent({
  name: 'KdgAdminNotification',
  components: {Multiselect, VueLoading},
  setup() {
    const pageResponse = ref<PageResponse<KdgLmsSystemNotificationDto>>();
    const items = ref<KdgLmsSystemNotificationDto[]>([]);
    const currentPage = ref(1);
    const page = ref(1);
    const pageSize = ref(10);
    const searchParams = reactive(new KdgNotificationSearchParam());
    const searchMessageParams = reactive(new KdgNotificationSearchParam());
    const kato = ref<Kato | null>(null);
    const katoList = ref<Kato[]>([]);
    const isLoading = ref(false);
    const isFormLoading = ref(false);
    const showModal = ref(false);
    const hasAccess = authService.hasAccess;
    const adminRoles = authService.getAdminRoles();
    const managerSpkRoles = authService.getManagerSpkRoles();
    const isEditable = hasAccess(adminRoles) || hasAccess(managerSpkRoles);
    let lmsSystemNotificationDto = ref<KdgLmsSystemNotificationDto | null>(null);
    let messages = ref<KdgLmsSystemNotificationMessageDto[]>([]);
    const messageDto = ref<string>('');
    const messageModalTitle = ref<string>('');
    const fileInput = ref<HTMLInputElement | null>(null);
    const messageSelectedFiles = ref<File[]>([]);
    searchMessageParams.pageSize = 10;
    const fetchCachedData = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const fetchReports = async (isPageDefault: boolean = false) => {
      try {
        if (isPageDefault) {
          searchParams.page = 0;
          currentPage.value = 1;
        }
        if (kato.value) {
          searchParams.katoCode = kato.value?.code;
        }
        pageResponse.value = await findAllLmsSystemNotification(searchParams);
        items.value = pageResponse.value.content;
      } catch (error) {
        console.error('Ошибка при получении отчетов:', error);
      }
    };

    const loadOldMessages = () => {
      searchMessageParams.page++;
      loadLmsSystemNotificationMessages(true);
    };

    watch(currentPage, (newPage) => {
      searchParams.page = newPage - 1;
      fetchReports();
    });

    const changePageElementSize = (pageSize: number) => {
      searchParams.pageSize = pageSize;
      console.log("searchParams", pageSize, searchParams);
      fetchReports();
    }

    const getLastMessageStatusText = (status: string) => {
      switch (status) {
        case 'DELIVERED':
          return 'Доставлено';
        case 'SENT':
          return 'Отправлено';
        default:
          return '';
      }
    };
    const getFundingStatusText = (status: string | undefined) => {
      switch (status) {
        case 'IN_PROGRESS':
          return 'Осуществляется';
        case 'SUSPENDED':
          return 'Приостановелено';
        default:
          return '';
      }
    };


    onMounted(() => {
      fetchReports();
      fetchCachedData();
    });

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const clearSearchParam = () => {
      kato.value = null;
      searchParams.name = null;
      searchParams.executor = null;
      searchParams.bin = null;
      searchParams.notificationStatus = null;
      searchParams.fundingStatus = null;
      searchParams.katoCode = null;
    }

    const getKatoNameRu = (katoCode: number | undefined) => {
      const kato = katoList.value.find(kato => kato.code === katoCode);
      return kato ? kato.nameRu : "";
    }

    const downloadGeneratedCalculationReportList = async () => {
      try {
        isLoading.value = true;
        if (kato.value) {
          searchParams.katoCode = kato.value?.code;
        }
        await getGenerateAndExportListAsXLSX(searchParams);
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    const openNotificationModal = (item: KdgLmsSystemNotificationDto) => {
      showModal.value = true;
      lmsSystemNotificationDto.value = item;
      messageDto.value = '';
      messageModalTitle.value = 'LMS ID: ' + item.lmsId + ', БИН: ' + item.bin + ", " + item.kindergartenName;

      messageSelectedFiles.value = [];
      console.log('openNotificationModal', item);
      searchMessageParams.page = 0;

      if (item.kdgNotificationId) {
        loadLmsSystemNotificationMessages();
      } else {
        messages.value = [];
      }
    }

    const startNotification = async (status: boolean) => {
      console.log('startNotification', status);
      if (lmsSystemNotificationDto) {
        const dto = ref<KdgLmsSystemNotificationRequestDto>({
          status: status,
          lmsSystemId: lmsSystemNotificationDto.value?.id,
          kdgNotificationId: lmsSystemNotificationDto.value?.kdgNotificationId
        });
        const result = await startLmsSystemNotificationMessage(dto.value);
        if (result) {
          loadLmsSystemNotificationDto();
        }
      }
    }

    const startLmsSystemFunding = async (status: boolean) => {
      console.log('startLmsSystemFunding', status)


      let fundingStatus = status ? 'IN_PROGRESS' : 'SUSPENDED';

      const result = await updateLmsSystemFundingStatus(lmsSystemNotificationDto.value?.id, fundingStatus);
      console.log('updateLmsSystemFundingStatus', fundingStatus, result);
      if (result) {
        loadLmsSystemNotificationDto();
      }
    }

    const sendMessage =  async () => {
      if (!messageDto.value.trim().length) {
        showErrorNotification('Сообщение пустое');
        return;
      }

      if (messageSelectedFiles.value.length) {
        sendMessageWithFiles();
        return;
      }
      if (lmsSystemNotificationDto) {
        const dto = ref<KdgLmsSystemNotificationMessageRequestDto>({
          message: messageDto.value,
          lmsSystemId: lmsSystemNotificationDto.value?.id,
          kdgNotificationId: lmsSystemNotificationDto.value?.kdgNotificationId
        });
        const result = await sendLmsSystemNotificationMessage(dto.value);
        if (result) {
          messageDto.value = '';
          loadLmsSystemNotificationMessages();
        }
      }
    }
    // Upload file using FormData
    const sendMessageWithFiles = async () => {
      // if (!messageSelectedFiles.value) {
      //   alert("Please select a file first!");
      //   return;
      // }

      const formData = new FormData();
      if (lmsSystemNotificationDto.value?.kdgNotificationId) {
        formData.append('kdgNotificationId', lmsSystemNotificationDto.value.kdgNotificationId);
      }
      if (lmsSystemNotificationDto.value?.id) {
        formData.append('lmsSystemId', lmsSystemNotificationDto.value.id + '');
      }
      formData.append('message', messageDto.value);

      for (let i = 0; i < messageSelectedFiles.value.length; i++) {
        formData.append("file[]", messageSelectedFiles.value[i], messageSelectedFiles.value[i].name); // Attach file to FormData
      }

      try {
        const result = await sendLmsSystemNotificationMessageWithFiles(formData);
        if (result) {
          messageDto.value = '';
          loadLmsSystemNotificationMessages();
          console.log("Upload success:", result);
          messageSelectedFiles.value = [];
          // alert("File uploaded successfully!");
        } else {
          showErrorNotification("Возникла ошибка при отправке файла на сервер, пожалуйста попробуйте еще раз");
        }

      } catch (error) {
        console.error("Upload error:", error);
        alert("File upload failed.");
        showErrorNotification("Возникла ошибка при отправке файла на сервер, пожалуйста попробуйте еще раз");
      }
    }

    // Метод для триггера input
    const triggerFileInput = () => {
      if (fileInput.value) {
        fileInput.value.click(); // Use `.value` to access the DOM element
      }
      // const fileInput = ref<HTMLInputElement | null>(null);
      // if (fileInput.value) {
      //   fileInput.value.click();
      // }
    };
    const handleFileUpload = (event: any) => {
      console.log(event.target.files)
      const files = event.target.files;
      if (!files.length) {
        showErrorNotification("Выберите файл для загрузки");
        return;
      }

      // Вывод информации о файлах в консоль
      console.log("Выбранные файлы:", files);

      // Пример: валидация файла
      // const allowedTypes = ['application/pdf', 'application/msword',
      //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      //   'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      //
      // for (const file of files) {
      //   if (!allowedTypes.includes(file.type)) {
      //     showErrorNotification(`Файл "${file.name}" имеет неподдерживаемый формат!`);
      //     return;
      //   }
      // }

      // messageSelectedFiles.value = files;
      messageSelectedFiles.value = [...files];
    }
    const removeFile = (index: number) => {
      messageSelectedFiles.value.splice(index, 1);
    }
    const loadLmsSystemNotificationDto = async () => {
      lmsSystemNotificationDto.value = await findByIdLmsSystemNotification(lmsSystemNotificationDto.value?.id);
      items.value.forEach(e => {
        if (e.id === lmsSystemNotificationDto.value?.id) {
          e.kdgNotificationId = lmsSystemNotificationDto.value?.kdgNotificationId;
          e.fundingStatus = lmsSystemNotificationDto.value?.fundingStatus;
        }
      });
    }

    const loadLmsSystemNotificationMessages = async (isAppendMessage: boolean = false) => {
      const item = await getLmsSystemNotificationMessages(lmsSystemNotificationDto.value?.kdgNotificationId, searchMessageParams, false);

      if (isAppendMessage) {
        messages.value.unshift(...item.content);
      } else {
        messages.value = item.content;
      }
    }


    const downloadFile = async (file: any) => {
      isLoading.value = true;
      const response = await downloadFileById(file.id);
      const blob = new Blob([response.data], {type: file.contentType});
      saveAs(blob, file.fileName);
      isLoading.value = false;
    }

    return {
      items,
      pageResponse,
      page,
      pageSize,
      currentPage,
      searchParams,
      isLoading,
      kato,
      katoList,
      isFormLoading,
      showModal,
      lmsSystemNotificationDto,
      messageDto,
      messages,
      messageModalTitle,
      fileInput,
      messageSelectedFiles,
      adminRoles,
      managerSpkRoles,
      isEditable,
      fetchReports,
      loadOldMessages,
      formattedKatoLabel,
      clearSearchParam,
      getKatoNameRu,
      getLastMessageStatusText,
      getFundingStatusText,
      downloadGeneratedCalculationReportList,
      changePageElementSize,
      openNotificationModal,
      startNotification,
      startLmsSystemFunding,
      sendMessage,
      handleFileUpload,
      triggerFileInput,
      removeFile,
      downloadFile
    };
  },
  methods: {

  }

});
</script>

<style scoped>

.rejected-status {
  color: red;
}


.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}


/*  chat */


.inbox_msg {
  border: 1px solid #c4c4c4;
  clear: both;
  overflow: hidden;
}
.top_spac{ margin: 20px 0 0;}

.incoming_msg_img {
  display: inline-block;
  width: 6%;
}
.incoming_msg_img img {
  height: 40px;
}
.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}
.received_withd_msg p {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
}
.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}
.received_withd_msg { width: 57%;}
.mesgs {
  float: left;
  padding: 0px 15px 0 25px;
  width: 100%;
}

.sent_msg p {
  background: #05728f none repeat scroll 0 0;
  border-radius: 3px;
  font-size: 14px;
  margin: 0; color:#fff;
  padding: 5px 10px 5px 12px;
  width:100%;
}
.outgoing_msg, .incoming_msg{ overflow:hidden; margin:20px 0 20px;}
.sent_msg {
  float: right;
  width: 46%;
}
.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: #4c4c4c;
  font-size: 15px;
  min-height: 48px;
  width: 100%;
}

.type_msg {border-top: 1px solid #c4c4c4;position: relative;}

.msg_send_btn {
  background: #05728f none repeat scroll 0 0;
  border: medium none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  height: 33px;
  position: absolute;
  right: 35px;
  top: 11px;
  width: 33px;
}
.upload_send_btn {
    background: #05728f none repeat scroll 0 0;
    border: medium none;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    font-size: 17px;
    height: 33px;
    position: absolute;
    right: 0;
    top: 11px;
    width: 33px;
  }
.messaging { padding: 0 0 50px 0;}
.msg_history {
  height: 516px;
  overflow-y: auto;
}

.selected-file-item span {
  font-size: 10px;
  padding-right: 10px;
  a {
    text-decoration: none;
    cursor: pointer;
  }
}
.padding-r-5px {
  padding-right: 5px;
}
</style>
